import React from 'react'
import classes from './Footer.module.css';
const Footer = () => {
    return (
        <div>
            <div className={classes.copyright}>
                <p>Copyright © 2025 Promix Accounting. All rights reserved.</p>
                <p>
                    Terms&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Ask&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Our and Downloads&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Contact Us&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Need Help?&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                    Feedback
                </p>
            </div>
        </div>
    )
}
export default Footer
